import { SALES_WHATSAPP } from "@/constants";

/** Link al WhatsApp de ventas con el mensaje ya escrito. */
export function salesWhatsappLink(message: string): string {
  return `https://wa.me/${SALES_WHATSAPP}?text=${encodeURIComponent(message)}`;
}
